export default class LoginModel{
    Email:string = '';
    Password:string = '';
    constructor(obj?: Partial<LoginModel>) {
        if(obj) {
            Object.assign(this, obj)
        }
    }
}